//BREEZE-8190 : Basket Order Recommendation : ManasaB : 26-08-2025 : Start
import { memo } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { BzModal, BzModalHeader, BzModalBody, BzButton, BzModalFooter } from '../../components/';
import { useDispatch, useSelector } from 'react-redux';
import { handleModal, handleModalData } from '../../redux/actions/modals';
import { ORDER_TYPES } from '../../utils/global_variables';


const CustomiseCartAlertModal = () => {

    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);
    const onHandleClose = () => {
        dispatch(handleModal([{ 'CUSTOMISE_CART_ALERT_MODAL': false }]));
    };

    const handleCancel = () => {
        dispatch(handleModal([{ 'CUSTOMISE_CART_ALERT_MODAL': false }, true]));
    };
    const handleProceed = () => {
        dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }, { 'CUSTOMISE_CART_ALERT_MODAL': false }, { "RECOMMENDATION_CART_MODAL": false }, true]));
        dispatch(handleModalData({ data: { activeTabKey: ORDER_TYPES.BASKET, orderEntryTab: ORDER_TYPES.MULTI_SCRIP, bIsBasket: true, orderFrom: 'BasketReco' } }));
    };
    return (
        <>
            <BzModal size='sm' show={modals['CUSTOMISE_CART_ALERT_MODAL']} onHide={onHandleClose}>
                <BzModalHeader className='modaltabs-header'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={11} className='d-flex justify-content-start align-items-center'>
                                <div className='font-medium font-size4 color-text'>Customize Cart</div>
                            </Col>
                            <Col md={1} className='d-flex justify-content-end align-items-center'>
                                <div className='icon-16 icon-dark icon-close' onClick={onHandleClose}></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody>
                    <Container fluid className='p-0'>
                        <Row className='g-0 mb-3'>
                            <Col className='d-flex justify-content-start'>
                                <div className='font-regular font-size3 color-text'>By choosing this option you will be converting the recommended cart into your own.Are you sure you want to proceed?</div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalBody>
                <BzModalFooter>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col className='d-flex justify-content-end'>
                                <BzButton className='btn btn-md btn-outline me-2' onClick={handleCancel}>CANCEL</BzButton>
                                <BzButton className='btn btn-md btn-primary ms-2' onClick={handleProceed}>YES,PROCEED</BzButton>
                            </Col>
                        </Row>
                    </Container>
                </BzModalFooter>
            </BzModal>

        </>
    );
};

export default memo(CustomiseCartAlertModal);
//BREEZE-8190 : Basket Order Recommendation : ManasaB : 26-08-2025 : End
